import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import eventBus from '../eventBus';
import './MobileBottomNav.css';

const getAccountLink = () => {
  if (localStorage.getItem('technician_token')) return '/tech-dashboard';
  if (localStorage.getItem('user_token') || localStorage.getItem('auth_token')) return '/profile';
  return '/login';
};

const Icon = ({ name }) => {
  const paths = {
    home: <><path d="m3 10 9-7 9 7" /><path d="M5 9v12h14V9M9 21v-7h6v7" /></>,
    services: <><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M3 10h18M9 10v10" /></>,
    categories: <><rect x="3" y="3" width="8" height="8" rx="2" /><rect x="13" y="3" width="8" height="8" rx="2" /><rect x="3" y="13" width="8" height="8" rx="2" /><rect x="13" y="13" width="8" height="8" rx="2" /></>,
    account: <><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></>
  };

  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {paths[name]}
    </svg>
  );
};

const MobileBottomNav = () => {
  const [accountLink, setAccountLink] = useState(getAccountLink);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const updateAccount = () => setAccountLink(getAccountLink());
    const handleStorage = () => updateAccount();
    eventBus.on('userLoggedIn', updateAccount);
    eventBus.on('userLoggedOut', updateAccount);
    window.addEventListener('storage', handleStorage);
    return () => {
      eventBus.off('userLoggedIn', updateAccount);
      eventBus.off('userLoggedOut', updateAccount);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  useEffect(() => {
    if (location.pathname !== '/' || location.hash !== '#categories') return undefined;

    let attempts = 0;
    let timeoutId;
    const scrollToCategories = () => {
      const categories = document.getElementById('categories');
      if (categories) {
        categories.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else if (attempts < 30) {
        attempts += 1;
        timeoutId = window.setTimeout(scrollToCategories, 100);
      }
    };

    timeoutId = window.setTimeout(scrollToCategories, 0);
    return () => window.clearTimeout(timeoutId);
  }, [location.pathname, location.hash]);

  const handleCategoryClick = (event) => {
    event.preventDefault();
    if (location.pathname === '/' && location.hash === '#categories') {
      document.getElementById('categories')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      navigate('/#categories');
    }
  };

  const links = [
    { label: 'Home', to: '/', icon: 'home', end: true },
    { label: 'Services', to: '/services', icon: 'services' },
    { label: 'Categories', to: '/#categories', icon: 'categories', category: true },
    { label: accountLink === '/login' ? 'Login' : 'Account', to: accountLink, icon: 'account' }
  ];

  return (
    <nav className="mobile-bottom-nav" aria-label="Main mobile navigation">
      {links.map(({ label, to, icon, end, category }) => (
        <NavLink
          key={label}
          to={to}
          end={end}
          onClick={category
            ? handleCategoryClick
            : icon === 'account' && accountLink !== '/login'
              ? (event) => {
                  event.preventDefault();
                  eventBus.emit('openProfileModal');
                }
              : undefined}
          className={({ isActive }) => (
            `mobile-bottom-nav__item${isActive && (!category || location.hash === '#categories') && (icon !== 'home' || !location.hash) ? ' is-active' : ''}`
          )}
          aria-label={label}
        >
          <Icon name={icon} />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default MobileBottomNav;
